import styled, { css } from 'styled-components';

export const InputText = styled.input`
    width:243px;
    height:72px;
    border-radius: 13px;
    border: solid 1px #d7d7d7;
    font-family:'Gilory-Semi';
    font-size: 18px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #9b9b9b;
    padding-left:20px; 
    ${props =>
    props.profile &&
    css`
        width: 223px;
      `}
    ${props =>
    props.highlight &&
    css`
        font-family: 'Gilory-Bold';
      `} 
    ${props =>
    props.small &&
    css`
        width: 150px;
        height: 40px;
      `}
`;

export const HeaderTextView = styled.span`
    font-family:'Gilory-Semi';
    font-size: 20px;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #d7d7d7;
    ${props =>
    props.marginRight &&
    css`
        margin-right: 10px;
      `}
    ${props =>
    props.selected &&
    css`
        color: #767676;
        font-family: 'Gilory-Bold';
      `}
    ${props =>
    props.cursor &&
    css`
        cursor: pointer;
      `}
`;

export const ProfileInputText = styled.div`
  font-family: 'Gilory-Bold';
  font-size: 20px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #484848;
`;

export const ProfileInputView = styled.div`
  font-family: 'Gilory-Bold';
  font-size: 18px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #484848;
  text-wrap: nowrap;
`;

export const HeaderSelected = styled.span`
  font-family: 'Gilory-Semi';
  font-size: 20px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  font-weight: 800;
  color: #767676
    ${props =>
    props.marginRight &&
    css`
        margin-right: 10px;
      `};
`;

export const HeaderNotSelected = styled(HeaderSelected)`
  color: #d7d7d7;
  font-family: 'Gilory-Bold';
`;

export const PeopleHeaderText = styled.span`
  font-family: 'Gilory-Semi';
  font-size: 20px;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #767676
    ${props =>
    props.highlight &&
    css`
        font-family: 'Gilory-Bold';
      `}
    ${props =>
    props.spam &&
    css`
        color: #eb5252;
      `}
    ${props =>
    props.small &&
    css`
        font-size: 18px;
      `}
    ${props =>
    props.marginLeft &&
    css`
        margin-left: 10px;
      `};
`;

export const CommonTextStyle = styled.div`
  font-family: 'Gilory-Semi';
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #d7d7d7;
  ${props =>
    props.highlight &&
    css`
      color: #9b9b9b;
    `}
  ${props =>
    props.grey &&
    css`
      color: #484848;
    `}
  ${props =>
    props.cursor &&
    css`
      cursor: pointer;
    `}
`;

export const CommonTextStyleSpan = styled.span`
  font-family: 'Gilory-Semi';
  font-size: 20px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #d7d7d7;
  ${props =>
    props.highlight &&
    css`
      color: #9b9b9b;
      font-family: 'Gilory-Bold';
      font-weight: 800;
    `}
  ${props =>
    props.grey &&
    css`
      color: #484848;
      font-family: 'Gilory-Bold';
      font-weight: 800;
    `}
  ${props =>
    props.show_cursor &&
    css`
      cursor: pointer;
    `}
`;

export const MemberSearchInput = styled.input`
  width: 162px;
  height: 45px;
  padding-left: 20px;
  border-radius: 30px;
  background-color: #ffffff;
  font-family: 'Gilory-Semi';
  font-size: 20px;
  color: #9b9b9b;
  border-width: 0px;
`;

export const MemberSearchText = styled.div`
  width: 100%;
  border-radius: 30px;
  font-family: 'Gilory-Semi';
  font-size: 20px;
  color: #9b9b9b;
  margin-bottom: 5px;
  margin-top: 12px;
  text-align: center;
`;

export const RowTextStyle = styled(CommonTextStyleSpan)`
  width: 100px;
  ${props =>
    props.width &&
    css`
      width: ${props.width};
    `};
`;
